import { Link, useLocation } from "react-router-dom";
import styles from "./navbar.module.css";
import NavbarItem from "../../screens/navbar-item";
import { MyIcons } from "../../icons/my-icons";
import NavbarAction from "../../screens/navbar-action";
import { useState, useRef } from "react";
import Input from "../../ui/input";
import { useNavigate } from "react-router-dom";
import ToolsModal from "../../modals/tools-modal/index";
import AdvanceSearchModal from "../../modals/advance-search-modal/index";
import HonorariosPagadosModal from "../../modals/HonorariosPagadosModal";
import { getRecordById } from "../../../services/apiService";

const Navbar = () => {
  const userRole = localStorage.getItem("userRole") || "ROLE_USER";
  const userName =
    localStorage.getItem("userName") ||
    localStorage.getItem("username") ||
    "Usuario";
  const location = useLocation();
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(true);
  const [isToolsMenuOpen, setIsToolsMenuOpen] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const toolsRef = useRef();
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
  const [isHonorariosPagadosModalOpen, setIsHonorariosPagadosModalOpen] = useState(false);

  // Estados para el buscador de expedientes
  const [searchId, setSearchId] = useState("");
  const [searchMessage, setSearchMessage] = useState("");
  const [isSearching, setIsSearching] = useState(false);

  const toggleNavbar = () => {
    setIsExpanded(!isExpanded);
  };

  const calculateMenuPosition = (ref, menuEstimatedHeight = 200) => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      const menuEstimatedWidth = 220;

      // Posicionar el menú a la derecha del item
      let top = rect.top;
      let left = rect.right + 10;

      // Si se sale por abajo, moverlo hacia arriba
      if (top + menuEstimatedHeight > windowHeight) {
        top = windowHeight - menuEstimatedHeight - 10;
        if (top < 10) {
          top = Math.max(10, (windowHeight - menuEstimatedHeight) / 2);
        }
      }

      // Si el menú se sale por la derecha, colocarlo a la izquierda
      if (left + menuEstimatedWidth > windowWidth) {
        left = rect.left - menuEstimatedWidth - 10;
        if (left < 10) {
          left = 10;
        }
      }

      return { top, left };
    }
    return { top: 0, left: 0 };
  };

  const handleToolsClick = (e) => {
    if (!["ROLE_ADMIN", "ROLE_USER", "ROLE_MANAGER"].includes(userRole)) {
      return;
    }
    setMenuPosition(calculateMenuPosition(toolsRef, 150));
    setIsToolsMenuOpen(!isToolsMenuOpen);
    e.stopPropagation();
  };

  const handleSearchClick = () => {
    setIsSearchModalOpen(true);
  };

  // Función para buscar expediente por ID
  const handleSearchById = async () => {
    if (!searchId.trim()) {
      setSearchMessage("Por favor ingrese un ID de expediente");
      return;
    }

    setIsSearching(true);
    setSearchMessage("");

    try {
      const record = await getRecordById(searchId.trim());
      if (record) {
        // Si encuentra el expediente, navegar a él
        navigate(`/record/${searchId.trim()}`);
        setSearchId("");
        setSearchMessage("");
      }
    } catch (error) {
      console.error("Error searching record:", error);
      setSearchMessage("No se encontró el expediente con ese ID");
    } finally {
      setIsSearching(false);
    }
  };

  // Herramientas - Solo Gmail y Verifactu quedan aquí
  const toolsMenuItems = [
    {
      label: "Gmail",
      hasSubmenu: true,
      submenu: [
        {
          label: "Reautorizar",
          action: async () => {
            try {
              const { getGmailAuthUrl } = await import(
                "../../../services/apiService"
              );
              const response = await getGmailAuthUrl();
              if (response.url) {
                window.open(response.url, "_blank");
              }
            } catch (error) {
              console.error("Error getting Gmail auth URL:", error);
            }
          },
        },
      ],
    },
    {
      label: "Verifactu",
      hasSubmenu: true,
      submenu: [
        {
          label: "Ver documentos",
          action: () => console.log("Ver documentos Verifactu"),
        },
      ],
    },
  ];

  const cosas_que_no_van_todavia = [
    {
      /*
      label: "Lista de gestión",
      hasSubmenu: true,
      submenu: [
        {
          label: "Expedientes",
          action: () => console.log("Expedientes"),
        },
        {
          label: "Listado margen bruto",
          action: () => console.log("Listado margen bruto"),
        },
        {
          label: "Margen bruto facturas por gremio",
          action: () => console.log("Margen bruto facturas por gremio"),
        },
        {
          label: "Facturas pendientes de cobro",
          action: () => console.log("Facturas pendientes de cobro"),
        },
        {
          label: "Facturas cobradas",
          action: () => console.log("Facturas cobradas"),
        },
        {
          label: "Ratio facturas pendientes cobro",
          action: () => console.log("Ratio facturas pendientes cobro"),
        },
        {
          label: "Listado historico alarmas",
          action: () => console.log("Listado historico alarmas"),
        },
      ],
    */
    },
    {
      /*
      label: "Reparación consolidado",
      hasSubmenu: true,
      submenu: [
        {
          label: "Top lunes administradores consolidado",
          action: () => console.log("Top lunes administradores consolidado"),
        },
        {
          label: "Top lunes comercial consolidado",
          action: () => console.log("Top lunes comercial consolidado"),
        },
      ],
    */
    },
    {
      /*
      label: "Lista administrador",
      hasSubmenu: true,
      submenu: [
        {
          label: "Listado 347",
          action: () => console.log("Listado 347"),
        },
        {
          label: "Listado de facturas por Ivas",
          action: () => console.log("Listado de facturas por Ivas"),
        },
        {
          label: "Listado de facturas",
          action: () => console.log("Listado de facturas"),
        },
      ],
    */
    },
    {
      /*
      label: "Lista secundario",
      hasSubmenu: true,
      submenu: [
        {
          label: "Resumen de facturación",
          action: () => console.log("Resumen de facturación"),
        },
        {
          label: "Resumen pagos por gremio",
          action: () => console.log("Resumen pagos por gremio"),
        },
      ],
    */
    },
    {
      /*
      label: "Cobrar",
      hasSubmenu: true,
      submenu: [
        {
          label: "Pendiente",
          action: () => console.log("Pendiente"),
        },
      ],
    */
    },
    {
      /*
      label: "Honorarios",
      hasSubmenu: true,
      submenu: [
        {
          label: "Pendiente",
          action: () => console.log("Pendiente"),
        },
      ],
    */
    },
    {
      /*
      id: "help",
      label: "Ayuda",
      icon: "helpCircle",
      action: () => console.log("Ayuda"),
    */
    },
  ];

  return (
    <nav
      className={`${styles.navbar} ${
        isExpanded ? styles.expanded : styles.collapsed
      }`}
    >
      <div className={styles.navbarHeader}>
        <div
          className={styles.userSection}
          onClick={() => navigate("/profile")}
          style={{ cursor: "pointer" }}
        >
          <div className={styles.userIcon}>
            <MyIcons name="user" width={24} height={24} color="var(--white)" />
          </div>
          {isExpanded && <span className={styles.userName}>{userName}</span>}
        </div>

        <div
          className={`${!isExpanded && styles.toggleIcon}`}
          onClick={toggleNavbar}
        >
          <MyIcons
            name={isExpanded ? "arrowLeft" : "arrowRight"}
            width={24}
            height={24}
            color="var(--white)"
          />
        </div>
      </div>

      <ul className={styles["navLinks"]}>
        {/* Alarmas - ROLE_USER, ROLE_MANAGER, ROLE_ADMIN */}
        {(userRole === "ROLE_USER" ||
          userRole === "ROLE_MANAGER" ||
          userRole === "ROLE_ADMIN") && (
          <li>
            <Link to="/alarms">
              <NavbarItem
                name="Alarmas"
                icon="alarm"
                filledIcon="alarmFilled"
                isActive={location.pathname === "/alarms"}
                isExpanded={isExpanded}
              />
            </Link>
          </li>
        )}

        {/* Citas (Management) - ROLE_MANAGER, ROLE_ADMIN */}
        {(userRole === "ROLE_MANAGER" || userRole === "ROLE_ADMIN") && (
          <li>
            <Link to="/appointments-management">
              <NavbarItem
                name="Partes"
                icon="appointment"
                filledIcon="appointmentFilled"
                isActive={location.pathname === "/appointments-management"}
                isExpanded={isExpanded}
              />
            </Link>
          </li>
        )}

        {/* Calendario - Todos los roles */}
        {(userRole === "ROLE_USER" ||
          userRole === "ROLE_MANAGER" ||
          userRole === "ROLE_ADMIN" ||
          userRole === "ROLE_OPERARIO") && (
          <li>
            <Link to="/calendar">
              <NavbarItem
                name="Calendario"
                icon="calendar"
                filledIcon="calendarFilled"
                isActive={location.pathname === "/calendar"}
                isExpanded={isExpanded}
              />
            </Link>
          </li>
        )}

        {/* Citas (Operario) - Solo ROLE_OPERARIO */}
        {userRole === "ROLE_OPERARIO" && (
          <>
            <li>
              <Link to="/appointments-pending">
                <NavbarItem
                  name="Pendientes"
                  icon="appointment"
                  filledIcon="appointmentFilled"
                  isActive={location.pathname === "/appointments-pending"}
                  isExpanded={isExpanded}
                />
              </Link>
            </li>
            <li>
              <Link to="/appointments-upcoming">
                <NavbarItem
                  name="Próximas Citas"
                  icon="calendar"
                  filledIcon="calendarFilled"
                  isActive={location.pathname === "/appointments-upcoming"}
                  isExpanded={isExpanded}
                />
              </Link>
            </li>
            <li>
              <Link to="/appointments-history">
                <NavbarItem
                  name="Historial"
                  icon="file"
                  filledIcon="fileFilled"
                  isActive={location.pathname === "/appointments-history"}
                  isExpanded={isExpanded}
                />
              </Link>
            </li>
          </>
        )}

        {/* Expedientes - ROLE_USER, ROLE_MANAGER, ROLE_ADMIN */}
        {(userRole === "ROLE_USER" ||
          userRole === "ROLE_MANAGER" ||
          userRole === "ROLE_ADMIN") && (
          <li>
            <Link to="/records">
              <NavbarItem
                name="Expedientes"
                icon="file"
                filledIcon="fileFilled"
                isActive={location.pathname === "/records"}
                isExpanded={isExpanded}
              />
            </Link>
          </li>
        )}

        {/* Panel de Control - Solo ROLE_ADMIN */}
        {userRole === "ROLE_ADMIN" && (
          <li>
            <Link to="/statistics">
              <NavbarItem
                name="Estadísticas"
                icon="stats"
                filledIcon="stats"
                isActive={location.pathname === "/statistics"}
                isExpanded={isExpanded}
              />
            </Link>
          </li>
        )}

        {/* Gestión de Usuarios - ROLE_MANAGER y ROLE_ADMIN */}
        {(userRole === "ROLE_MANAGER" || userRole === "ROLE_ADMIN") && (
          <li>
            <Link to="/user-management">
              <NavbarItem
                name="Gestión de Usuarios"
                icon="user"
                filledIcon="user"
                isActive={location.pathname === "/user-management"}
                isExpanded={isExpanded}
              />
            </Link>
          </li>
        )}

        {/* Tablas - Todos excepto OPERARIO */}
        {userRole !== "ROLE_OPERARIO" && (
          <li>
            <Link to="/tablas">
              <NavbarItem
                name="Tablas"
                icon="settings"
                filledIcon="settings"
                isActive={location.pathname === "/tablas"}
                isExpanded={isExpanded}
              />
            </Link>
          </li>
        )}

        {/* Cobros y Honorarios - SOLO ADMIN */}
        {userRole === "ROLE_ADMIN" && (
          <li>
            <Link to="/cobros-honorarios">
              <NavbarItem
                name="Cobros y Honorarios"
                icon="stats"
                filledIcon="stats"
                isActive={location.pathname === "/cobros-honorarios"}
                isExpanded={isExpanded}
              />
            </Link>
          </li>
        )}

        {/* Listas - Todos excepto OPERARIO */}
        {userRole !== "ROLE_OPERARIO" && (
          <li>
            <Link to="/listas">
              <NavbarItem
                name="Listas"
                icon="file"
                filledIcon="fileFilled"
                isActive={location.pathname === "/listas"}
                isExpanded={isExpanded}
              />
            </Link>
          </li>
        )}
      </ul>

      {/* Buscador de expedientes por ID */}
      <div className={styles.searchSection}>
        {isExpanded ? (
          <div className={styles.searchForm}>
            <div className={styles.searchInputContainer}>
              <Input
                placeholder="ID de expediente"
                value={searchId}
                onChange={(e) => setSearchId(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    handleSearchById();
                  }
                }}
                style={{
                  width: "100%",
                  fontSize: "12px",
                  height: "32px",
                  paddingRight: "32px",
                }}
                disabled={isSearching}
              />
              <button
                type="button"
                onClick={handleSearchById}
                className={styles.searchIcon}
                disabled={isSearching}
                title="Buscar expediente"
              >
                <MyIcons
                  name="search"
                  width={16}
                  height={16}
                  color="var(--dark-grey)"
                />
              </button>
            </div>
            {searchMessage && (
              <div className={styles.searchMessage}>{searchMessage}</div>
            )}
          </div>
        ) : (
          <div
            className={styles.searchIconOnly}
            onClick={() => setIsExpanded(true)}
            title="Buscar expediente"
          >
            <MyIcons
              name="search"
              width={20}
              height={20}
              color="var(--white)"
            />
          </div>
        )}
      </div>

      {/* Acciones específicas por rol */}
      {(userRole === "ROLE_USER" ||
        userRole === "ROLE_MANAGER" ||
        userRole === "ROLE_ADMIN") && (
        <div className={styles.actions}>
          <NavbarAction
            name="Búsqueda avanzada"
            icon="search"
            isExpanded={isExpanded}
            onPress={handleSearchClick}
          />

          <Link to="/create-record">
            <NavbarItem
              name="Crear expediente"
              icon="plus"
              filledIcon="plus"
              isActive={location.pathname === "/create-record"}
              isExpanded={isExpanded}
            />
          </Link>

          {/* Llamadas - No mostrar para operarios */}
          {userRole !== "ROLE_OPERARIO" && (
            <Link to="/calls">
              <NavbarItem
                name="Llamadas"
                icon="phone"
                filledIcon="phone"
                isActive={location.pathname === "/calls"}
                isExpanded={isExpanded}
              />
            </Link>
          )}
        </div>
      )}

      {/* Herramientas - Disponible para USER, MANAGER y ADMIN */}
      {(userRole === "ROLE_USER" ||
        userRole === "ROLE_MANAGER" ||
        userRole === "ROLE_ADMIN") && (
        <div className={styles.actions}>
          <div ref={toolsRef}>
            <NavbarAction
              name="Herramientas"
              icon="settings"
              isExpanded={isExpanded}
              onPress={handleToolsClick}
            />
          </div>
        </div>
      )}

      {/* Remove logout section - moved to profile page */}
      <ToolsModal
        isOpen={isToolsMenuOpen}
        onClose={() => setIsToolsMenuOpen(false)}
        position={menuPosition}
        menuItems={toolsMenuItems}
      />

      <AdvanceSearchModal
        isOpen={isSearchModalOpen}
        onClose={() => setIsSearchModalOpen(false)}
      />

      <HonorariosPagadosModal
        isOpen={isHonorariosPagadosModalOpen}
        onClose={() => setIsHonorariosPagadosModalOpen(false)}
      />
    </nav>
  );
};

export default Navbar;
